module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beforeTxt),
      expression: "beforeTxt"
    }],
    staticClass: "layui-textarea",
    attrs: {
      "placeholder": "压缩后的JSON",
      "wrap": "off"
    },
    domProps: {
      "value": (_vm.beforeTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beforeTxt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('div', {
    staticStyle: {
      "border": "0",
      "width": "30%",
      "display": "inline-block",
      "line-height": "38px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replaceTxt),
      expression: "replaceTxt"
    }],
    staticClass: "layui-input",
    attrs: {
      "placeholder": "缩进",
      "type": "number"
    },
    domProps: {
      "value": (_vm.replaceTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replaceTxt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-button', {
    on: {
      "click": function($event) {
        _vm.convertFormatJson()
      }
    }
  }, [_c('span', [_vm._v("格式化\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-button', {
    on: {
      "click": function($event) {
        _vm.convertMiniJson()
      }
    }
  }, [_c('span', [_vm._v("压缩\n          "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v(" ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "layui-form-item layui-form-text"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.afterTxt),
      expression: "afterTxt"
    }],
    staticClass: "layui-textarea",
    attrs: {
      "placeholder": "格式化后端JSON",
      "rows": "13",
      "wrap": "off"
    },
    domProps: {
      "value": (_vm.afterTxt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.afterTxt = $event.target.value
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ce676418!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/jsonformat.vue
// module id = 330
// module chunks = 2